import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatDividerModule } from '@angular/material/divider'
import { MatInputModule } from '@angular/material/input'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTabsModule } from '@angular/material/tabs'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatDialog } from '@angular/material/dialog'
import {
  FormClientSearchComponent,
} from '../../../shared/components/form-client-search/form-search.component'
import { SubClientService } from '../../../core/services/customer/sub-client/sub-client.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  TableListConsultantComponent
} from '../../../shared/components/table-list-consultant/table-list-consultant.component'
import { cnpjTransform, cpfTransform, responseDefaultForm } from '../../../shared/utils/utils'
import { ErrorRequestModel, ResponseRequestModel } from '../../../core/models/response.model'
import { SubClientCreateComponent } from '../../customer/sub-client/sub-client-create/sub-client-create.component'
import { ClientService } from '../../../core/services/customer/client/client.service'
import { SearchEmployeeModel } from '../../../core/models/employee.model'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'

@Component({
  selector: 'associate-consultant-operate-edit',
  imports: [
    MatInputModule,
    MatPaginator,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBar,
    MatCardModule,
    MatDividerModule,
    MatTabsModule,
    FormClientSearchComponent,
    TableListConsultantComponent,
    MatButton,
    MatIcon,
  ],
  templateUrl: './associate-consultant-operate-edit.component.html',
  styleUrl: './associate-consultant-operate-edit.component.scss',
  providers: [SubClientService],
  standalone: true,
})
export class AssociateConsultantOperateEditComponent implements OnInit {
  constructor(
    private subClientService: SubClientService,
    private clientService: ClientService,
    private employeeService: EmployeeService,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  @Output() response = new EventEmitter()
  @Input() idClient = 0
  @Input() client = {}

  loadingBIcon: boolean = false

  loadingClient: boolean = false
  pageClient: number = 1
  rowsClient: number = 10
  totalClient: number = 0
  listClient: any[] = []
  columnsClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'action',
      key: { add: false, remove: true },
      description: 'Ações',
    },
  ]

  loadingNotClient: boolean = false
  pageNotClient: number = 1
  rowsNotClient: number = 10
  totalNotClient: number = 0
  listNotClient: any[] = []
  columnsNotClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'action',
      key: { add: true, remove: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    {
      id: 'nome',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'cpf',
      description: 'Cpf',
      type: 'string',
      visible: true,
    },
    {
      id: 'matricula',
      description: 'Matrícula',
      type: 'string',
      visible: true,
    },
    {
      id: 'email',
      description: 'Email',
      type: 'string',
      visible: true,
    },
  ]

  inputSearchClient: any = { type: '', search: '' }
  searchFormClient: any = { search: false, model: {} }

  inputSearchNotClient: any = { type: '', search: '' }
  searchFormNotClient: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getClientsBySubClient()
    this.getNotClientsBySubClient()
  }

  treatResponseClient(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        let cpf_cnpj =
          item.tipoPessoaId == 1
            ? cpfTransform(item.cpf)
            : cnpjTransform(item.cnpj)
        let nome_desc = item.tipoPessoaId == 1 ? item.nome : item.nomeFantasia
        list.push({
          ...item,
          nome_desc: nome_desc,
          tipo: item.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
          documento_identificacao: cpf_cnpj,
        })
      }
    }
    this.listClient = list
    this.totalClient = response.totalItens
  }

  treatResponseNotClient(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        let cpf_cnpj =
          item.tipoPessoaId == 1
            ? cpfTransform(item.cpf)
            : cnpjTransform(item.cnpj)
        let nome_desc = item.tipoPessoaId == 1 ? item.nome : item.nomeFantasia
        list.push({
          ...item,
          nome_desc: nome_desc,
          tipo: item.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
          documento_identificacao: cpf_cnpj,
        })
      }
    }
    this.listNotClient = list
    this.totalNotClient = response.totalItens
  }

  getClientsBySubClient() {
    this.loadingClient = true
    this.clientService.listPagedEmployeeAssociateByClientId(
      this.pageClient,
      this.rowsClient,
      this.idClient,
    )
    // this.subClientService
    //   .listPagedSubClientByClientId(
    //     this.idClient,
    //     this.pageClient,
    //     this.rowsClient,
    //   )
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
  }

  searchClientsBySubClient() {
    this.loadingClient = true
    this.clientService.searchPagedEmployeeAssociateByClientId(
      this.pageClient,
      this.rowsClient,
      this.searchFormClient.model,
      this.idClient    )
    // this.subClientService
    //   .searchPagedSubClientAssociate(
    //     this.pageClient,
    //     this.rowsClient,
    //     this.searchFormClient.model,
    //   )
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
    this.loadingClient = true
  }

  getNotClientsBySubClient() {
    this.loadingNotClient = true
    this.clientService.listPagedEmployeeNotAssociateByClientId(
      this.pageNotClient,
      this.rowsNotClient,
      this.idClient,
    )
    // this.subClientService
    //   .listPagedNotSubClientByClientId(
    //     this.idClient,
    //     this.pageNotClient,
    //     this.rowsNotClient,
    //   )
      .subscribe({
        next: (response: any) => {
          this.treatResponseNotClient(response)
          this.loadingNotClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingNotClient = false
        },
        complete: () => {
          this.loadingNotClient = false
        },
      })
  }

  searchNotClientsBySubClient() {
    this.loadingNotClient = true
    // this.subClientService
    //   .searchPagedSubClientAssociate(
    //     this.pageClient,
    //     this.rowsClient,
    //     this.searchFormNotClient.model,
    //   )
    this.clientService.searchPagedEmployeeNotAssociateByClientId(
      this.pageNotClient,
      this.rowsNotClient,
      this.searchFormNotClient.model,
      this.idClient    )
      .subscribe({
        next: (response: any) => {
          this.treatResponseNotClient(response)
          this.loadingNotClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingNotClient = false
        },
        complete: () => {
          this.loadingNotClient = false
        },
      })
  }

  uploadListClient(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchFormClient = { search: false, model: {} }
    }
    if (this.searchFormClient.search) {
      this.searchClientsBySubClient()
    } else {
      this.getClientsBySubClient()
    }
  }

  uploadListNClient(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchFormNotClient = { search: false, model: {} }
    }
    if (this.searchFormNotClient.search) {
      this.searchNotClientsBySubClient()
    } else {
      this.getNotClientsBySubClient()
    }
  }

  search(event: any, type: 'TClient' | 'TNClient') {
    if (event.search) {
      if (type == 'TClient') {
        this.searchFormClient = {
          search: true,
          model: this.createModel(event.data),
        }
      } else if (type == 'TNClient') {
        this.searchFormNotClient = {
          search: true,
          model: this.createModel(event.data, false),
        }
      }
    }
    if (type == 'TClient') {
      this.pageClient = 1
      this.uploadListClient(!event.search ? 'new' : '')
    } else if (type == 'TNClient') {
      this.pageNotClient = 1
      this.uploadListNClient(!event.search ? 'new' : '')
    }
  }

  createModel(element: any, associate: boolean = true) {
    let model: any = {
      pessoaId: 0,
      funcionarioFuncaoId: 1,
      statusId: 0,
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged($event: any, type: 'TClient' | 'TNClient') {
    if (type == 'TNClient') {
      this.pageNotClient = $event.pageIndex + 1
      this.rowsNotClient = $event.pageSize
      this.uploadListNClient()
    } else if (type == 'TClient') {
      this.pageClient = $event.pageIndex + 1
      this.rowsClient = $event.pageSize
      this.uploadListClient()
    }
  }

  addItem(element: any) {
    this.loadingBIcon = true
    // const model = {
    //   clienteId: this.idClient,
    //   subClienteId: element.id,
    // }
    const model = {
      funcionarioId: element.funcionarioId,
      clienteId: this.idClient,
    }
    this.employeeService.createAssociateClientsEmployee(model)
    // this.subClientService.addSubClientAtClient(model)
      .subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadListClient()
        this.uploadListNClient()
      },
      error: (err: ErrorRequestModel) => {
        this.loadingBIcon = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingBIcon = false
      },
    })
  }

  removeItem(element: any) {
    this.loadingBIcon = true
    // const model = {
    //   clienteId: this.idClient,
    //   subClienteId: element.id,
    // }
    const model = {
      funcionarioId: element.funcionarioId,
      clienteId: this.idClient,
    }
    this.employeeService.deleteAssociateClientsEmployee(model)
    // this.subClientService.removeSubClientAtClient(model)
      .subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadListClient()
        this.uploadListNClient()
      },
      error: (err: ErrorRequestModel) => {
        this.loadingBIcon = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingBIcon = false
      },
    })
  }

  createSubClient() {
    // let item = {
    //   id: 8,
    //   pessoaId: 11,
    //   tipoPessoaId: 2,
    //   tipoPessoa: 'PJ',
    //   pessoaJuridicaId: 8,
    //   subCliente: 'N',
    //   cnpj: '54421354000106',
    //   nomeFantasia: 'Marreco IA Inc.',
    //   razaoSocial: 'Marrecância IA',
    //   inscricaoEstadual: '982.106.990.021',
    //   inscricaoMunicipal: '982.106.990.021',
    // }
    const dialogRef = this.dialog.open(SubClientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item: this.client },
      // data: { item },
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadListClient()
      this.uploadListNClient()
    })
  }
}
